"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _framerMotion = require("framer-motion");

var _MotionFlex = _interopRequireDefault(require("../motionComponents/MotionFlex/MotionFlex"));

/* eslint-disable react/jsx-props-no-spreading */
var BaseOverlay = (0, _styledComponents["default"])(_MotionFlex["default"]).withConfig({
  displayName: "Overlay__BaseOverlay",
  componentId: "sc-14657fm-0"
})(["position:fixed;z-index:1000;top:0;left:0;"]);

var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["children"]);
  return _react["default"].createElement(BaseOverlay, (0, _extends2["default"])({}, props, {
    className: "overlay"
  }), children);
};

Overlay.propTypes = (0, _extends2["default"])({}, _MotionFlex["default"].propTypes, {
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].number]),
  bg: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].number]),
  flexDirection: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  justifyContent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  alignItems: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element]).isRequired
});
Overlay.defaultProps = {
  width: "100vw",
  height: "100vh",
  bg: "dark.3",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center"
};
var _default = Overlay;
exports["default"] = _default;